export default "__VITE_ASSET__e523572d__$_?component__"